<template>
<div class="SpaceSearchDraw">
  <div class="total" v-show="_activeIndex === 1 && tableData.length" style="margin-bottom: 0.16rem">
    <span class="line"></span>
    <span class="name">共查询到 {{total}} 条标注</span>
  </div>
  <ul class="scroll-table" v-show="resultData.length">
    <li class="head" :class="tableData.length>17?'active':''">
      <span>序号</span>
      <span style="text-align: left;padding-left: 0.12rem">标注名称</span>
      <span>类型</span>
    </li>
    <div class="scroll-table-body" v-infinite-scroll="load">
      <li v-for="(item,index) in tableData" :key="index" @click="toMarker(item)">
        <span style="color: #999999;">{{index + 1}}</span>
          <span style="text-align: left;padding-left: 0.12rem">
            <el-tooltip :content="item.name" placement="top" effect="light" :open-delay="1000">
              <span>
                {{item.name}}
              </span>
            </el-tooltip>
          </span>
        <span>{{item.type}}</span>
      </li>
    </div>
  </ul>
  <div class="result-box" v-if="_activeIndex === 2 && resultData.length && geometryStatistics.length">
    <div class="card">
      <div>
        <div><span class="dot"></span>线图层统计</div>
        <div><span class="nmu">{{geometryStatistics[1].count || 0}}</span>个</div>
      </div>
      <div>
        <div><span class="dot"></span>线长度合计</div>
        <div><span class="nmu">{{(geometryStatistics[1].calculation/1000).toFixed(2) || 0}}</span>km</div>
      </div>
    </div>
    <div class="card">
      <div>
        <div><span class="dot"></span>面图层统计</div>
        <div><span class="nmu">{{geometryStatistics[2].count || 0}}</span>个</div>
      </div>
      <div>
        <div><span class="dot"></span>面积合计</div>
        <div><span class="nmu">{{(geometryStatistics[2].calculation/1000000).toFixed(2) || 0}}</span>km²</div>
      </div>
    </div>
    <div class="card">
      <div>
        <div><span class="dot"></span>点图层统计</div>
        <div><span class="nmu">{{geometryStatistics[0].count || 0}}</span>个</div>
      </div>
    </div>
    <ul class="table">
      <li class="head">
        <span style="width: 4%"></span>
        <span>图层名称</span>
        <span>类型</span>
        <span>统计</span>
      </li>
      <li v-for="(item,index) in resultData" :key="index">
        <span :class="index<3?'active':''" style="width: 4%"><span>{{index + 1}}</span></span>
        <span class="name">{{item.name}}</span>
        <span>{{item.type}}</span>
        <span class="num">{{item.markCount}}</span>
      </li>
    </ul>
  </div>
  <Empty v-show="!tableData.length"></Empty>
  <div class="shade"
       v-if="showLoading"
       v-loading="true"
       element-loading-text="拼命加载中"
       element-loading-background="rgba(0, 0, 0, 0)">
  </div>
</div>
</template>

<script>
import { getSpaceSearchList, getSpaceSearchStatistics } from '@/api/marker'
import { mapGetters } from 'vuex'
export default {
  name: 'SpaceSearchDraw',
  props: {
    activeIndex: {
      type: Number,
      default: 1
    }
  },
  components: {},
  data () {
    return {
      tableData: [],
      resultData: [],
      geometryStatistics: [],
      params: {
        geoJson: {},
        mapId: 0,
        pageNumber: 1,
        pageSize: 20
      },
      total: 0,
      showLoading: false
    }
  },
  computed: {
    _activeIndex () {
      return this.activeIndex
    },
    ...mapGetters(['spaceSearchData', 'spaceSearchStatisticsData', 'spaceSearchJeojson'])
  },
  watch: {
    async spaceSearchJeojson (newValue, oldValue) {
      if (!newValue) {
        this.params.pageNumber = 1
        this.tableData = []
        this.resultData = []
        this.geometryStatistics = []
        this.$store.dispatch('showRight', false)
      } else {
        this.$emit('update:activeIndex', 1)
        this.params.pageNumber = 1
        await this.getSpaceSearchList()
        await this.getSpaceSearchStatistics()
      }
    }
  },
  methods: {
    async load () {
      if (this.tableData.length) {
        this.params.pageNumber++
        const res = await getSpaceSearchList(this.params)
        await this.getSpaceSearchStatistics()
        if (res.code === 200) {
          this.tableData = this.tableData.concat(res.data.records)
        }
      }
    },
    toMarker (item) {
      this.$emit('detailMarker', item.id)
    },
    // 获取空间查询列表结果
    async getSpaceSearchList () {
      this.showLoading = true
      this.params.mapId = parseInt(this.$route.query.mapId)
      this.params.geoJson = JSON.parse(this.spaceSearchJeojson)
      const res = await getSpaceSearchList(this.params)
      if (res.code === 200) {
        this.showLoading = false
        this.total = res.data.total
        this.tableData = res.data.records
        this.$nextTick(() => {
          this.$store.dispatch('showLeft', false)
          // this.$store.dispatch('showRight', true)
          // this.$store.dispatch('setDrawState', true)
        })
      }
    },
    async getSpaceSearchStatistics () {
      const res = await getSpaceSearchStatistics(this.params)
      if (res.code === 200) {
        // this.showLoading = false
        this.resultData = res.data.layerStatistics
        this.geometryStatistics = res.data.geometryStatistics
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.SpaceSearchDraw{
  position: relative;
  .scroll-table{
    list-style: none;
    width: 237px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 0;
    .head{
      height: 40px;
      background: rgba(255, 255, 255, 0.05);
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.active{
        overflow-y: scroll;
      }
      &.active::-webkit-scrollbar-thumb {
        border-radius: 0;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        background-color: rgba(55, 56, 57, 1) !important;
      }
      >span{
        display: inline-block;
        width: 50px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        &:nth-child(2){
          width: calc(100% - 100px);
          border-left: 1px solid rgba(255, 255, 255, 0.1);
          border-right: 1px solid rgba(255, 255, 255, 0.1);
        }
      }
    }
    .scroll-table-body{
      overflow-y: auto;
      max-height: 730px;
      padding: 0;
      >li{
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        &:nth-child(even){
          background: rgba(255, 255, 255, 0.05);
        }
        >span{
          display: inline-block;
          width: 50px;
          line-height: 40px;
          text-align: center;
          &:nth-child(2){
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: calc(100% - 100px);
            border-left: 1px solid rgba(255, 255, 255, 0.1);
            border-right: 1px solid rgba(255, 255, 255, 0.1);
          }
        }
      }
    }
  }
  .result-box{
    position: absolute;
    top: 0;
    left: 0;
    background-color: #2c2d2e;
    width: 102%;
    height: 102%;
    z-index: 100;
    .card{
      width: 240px;
      height: 64px;
      background: linear-gradient(-51deg, #3D76E9, #2C71E5);
      border-radius: 12px;
      margin-bottom: 8px;
      padding: 10px 14px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      >div{
        width: 50%;
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.7);
        .dot{
          display: inline-block;
          width: 6px;
          height: 6px;
          background: rgba(255, 255, 255, 0.7);
          border-radius: 50%;
          margin-right: 4px;
          transform: translateY(-1px);
        }
        .nmu{
          font-size: 20px;
          font-family: Arial;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    .table{
      list-style: none;
      padding: 0;
      height: 600px;
      overflow-y: auto;
      overflow-x: hidden;
      >li{
        width: 240px;
        height: 32px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 6px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #BBBBBB;
        padding-left: 8px;
        box-sizing: border-box;
        &.head{
          color: #999999;
        }
        >span{
          display: inline-block;
          width: 25%;
          text-align: left;
          &.active{
            >span{
              width: 15px;
              height: 15px;
              background: #46C38D;
              border-radius: 50%;
              display: inline-block;
              color: white;
              text-align: center;
              line-height: 15px;
            }
          }
        }
        .num{
          color: white;
        }
        .name{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .shade{
    position: absolute;
    z-index: 100;
    top: 0;
    width: 102%;
    height: 800px;
    background-color: rgb(44 45 46);
  }
}
</style>
